import Default from '../default/';

import axis from './axis';
import axisX from './axisX';
import axisY from './axisY';
import axisDefault from './axisDefault';
import axisExec from './axisExec';
import axisTitle from './axisTitle';
import renderAxis from './renderAxis';
import thickness from './thickness';

class RectLinear extends Default {
  constructor(appendedAttrs) {
    super(appendedAttrs);
  }
}


RectLinear.prototype.axis = axis;
RectLinear.prototype.axisX = axisX;
RectLinear.prototype.axisY = axisY;
RectLinear.prototype.axisDefault = axisDefault;
RectLinear.prototype.axisExec = axisExec;
RectLinear.prototype.axisTitle = axisTitle;
RectLinear.prototype.renderAxis = renderAxis;
RectLinear.prototype.thickness = thickness;


export default RectLinear;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/rectLinear/index.js